module.exports = __webpack_public_path__ + "img/logo.25d55f9c.svg";